<form [formGroup]="taxAuthorityForm" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-md-6 mb-3">
      <input-field
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter Code'"
        [required]="true"
        formControlName="code"
        [requiredLabel]="true"
        [errormessage]="'Code is required'"
      ></input-field>
    </div>
    <div class="col-md-6 mb-3">
      <input-field [label]="'Name'" [type]="'text'" [placeholder]="'Enter Name'" formControlName="name"></input-field>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="countriesList()"
        [label]="'Country'"
        [placeholder]="'Enter Country'"
        formControlName="countryId"
        [clearable]="true"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="provincesList()"
        [label]="'Province'"
        [placeholder]="'Enter Province'"
        formControlName="provinceId"
        [clearable]="true"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <div class="d-flex align-items-center gap-3">
        <p class="mb-1 fs-16">Reg No Exempt</p>
        <p-toggleswitch formControlName="regNoExempt" class="lh-1" />
      </div>
    </div>
  </div>
</form>
